import React, { useState } from "react";
import cn from "classnames";
import { useIntl } from "react-intl";

import { localizeInterval } from "../../../../../../../common/parameters";
import Draggable from "../../../../../Draggable";

import { Container, Button, SvgCanvas } from "./styles";
import { IProps } from "./interfaces";
import Grid, { unitWidth } from "./Grid";


const IntervalButton = ({ down = [0], up = [0], num, scale, isSeed, handleInput, x, hasLocal }: IProps) => {
    const { locale } = useIntl();
    const [posX, setPosX] = useState(0);
    const [inTransition, setInTransition] = useState(false);

    const onStart = () => {
        setInTransition(false);

    };
    const onDrag = (posX: number, posY: number) => {
        let newPosX = (posX + -posY) / 2;
        newPosX = Math.max(newPosX, -down[down.length - 1] * 64);
        newPosX = Math.min(newPosX, up[up.length - 1] * 64);
        setPosX(newPosX);
    };
    const onStop = () => {
        onEnd();
        setPosX(0);
        setInTransition(true);
    };
    const onEnd = () => {
        const text = getText();
        if ((text.length === 2 && text !== "10") || (text.length === 3 && text.indexOf("10") > -1)) {
            handleInput(text);
        }
    };
    const onClick = onEnd;

    const getText = () => {
        let letter = "";
        if (hasLocal || down.includes(1) || up.includes(1) || (!up && !down)) {
            letter = "T";
        }
        if (down.includes(0.5) && posX === -unitWidth / 2 * 3) {
            letter = "s";
        } else if (down.includes(1) && posX === -unitWidth * 2) {
            letter = "s";
        } else if (up.includes(0.5) && posX === unitWidth / 2 * 3) {
            letter = "B";
        } else if (up.includes(1) && posX === unitWidth * 2) {
            letter = "B";
        } else if (down.includes(0.5) && posX <= -unitWidth / 2) {
            letter = "k";
        } else if (down.includes(1) && posX <= -unitWidth) {
            letter = "s";
        } else if (up.includes(0.5) && posX >= unitWidth / 2) {
            letter = "N";
        } else if (up.includes(1) && posX >= unitWidth) {
            letter = "B";
        }

        return `${letter}${num}`;
    };

    const localizedInterval = localizeInterval(getText(), locale);
    return (
        <Container style={{ left: x * unitWidth - unitWidth / 4 }}>
            <SvgCanvas>
                {down && <Grid width={down.map(d => -d!)} />}
                {up && <Grid width={up.map(u => u!)} />}
            </SvgCanvas>
            <Draggable
                noBoundry
                transition={inTransition}
                scale={scale}
                position={{
                    x: posX,
                    y: -posX,
                }}
                onStart={onStart}
                onDrag={onDrag}
                onStop={onStop}
                onClick={onClick}
                disabled={isSeed}
            >
                <Button className={cn({ Small: localizedInterval.length >= 5, Seed: isSeed })}>
                    {!isSeed ? localizedInterval : ""}
                </Button>
            </Draggable>
        </Container>
    );
}

export default IntervalButton;
